import * as React from 'react';

export const useDataImportController = (onImportComplete?: () => void) => {
  const [importDataOpened, setImportDataOpenedState] = React.useState(false);

  const openImportData = React.useCallback(() => {
    setImportDataOpenedState(true);
  }, []);  
  const closeImportData = React.useCallback(() => {
    setImportDataOpenedState(false);
    // Call the callback to reload data when import dialog closes
    if (onImportComplete) {
      onImportComplete();
    }
  }, [onImportComplete]);

  return {
    importDataOpened,
    openImportData,
    closeImportData,
  };
};